// Generated from SVG to Code Figma Plugin
'use client';
import React from 'react';
import { chakra } from '@chakra-ui/react';

type Props = {
  width?: number;
  fill?: string;
};
export const Warning = ({ fill = 'none', width = 14 }: Props) => (
  <chakra.svg
    height={`${width}px`}
    width={`${width}px`}
    fill={fill}
    viewBox="0 0 14 14"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.99935 12.8332C3.77769 12.8332 1.16602 10.2215 1.16602 6.99984C1.16602 3.77817 3.77769 1.1665 6.99935 1.1665C10.221 1.1665 12.8327 3.77817 12.8327 6.99984C12.8327 10.2215 10.221 12.8332 6.99935 12.8332ZM6.99935 11.6665C9.57669 11.6665 11.666 9.57718 11.666 6.99984C11.666 4.42251 9.57669 2.33317 6.99935 2.33317C4.42202 2.33317 2.33268 4.42251 2.33268 6.99984C2.33268 9.57718 4.42202 11.6665 6.99935 11.6665ZM6.41602 8.74984H7.58268V9.9165H6.41602V8.74984ZM6.41602 4.08317H7.58268V7.58317H6.41602V4.08317Z"
      fill="#FE5B79"
    />
  </chakra.svg>
);
